import { render, staticRenderFns } from "./form-description.vue?vue&type=template&id=2771e1c8&"
import script from "./form-description.vue?vue&type=script&lang=ts&"
export * from "./form-description.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports